import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function StoryTelling() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // دايما يطلع لأول الصفحة عند أي تغيير في المسار أو الرجوع
    window.scrollTo(0, 0);
  }, [location.pathname, location.key]);
  return (
    <div onClick={() => navigate("/Sales")} className="cursor-pointer">
      <div className=" max-w-5xl mx-auto">
        <section>
          <img className=" " alt="hero-image" src="/doctor-photo.webp" />
        </section>
        <section className=" text-right p-8 bg-gray-300 shadow-md">
          <h2 class="text-2xl font-bold text-blue-700 mb-2">
            أكتر جملة بسمعها في العيادة
          </h2>
          <p class="text-lg mb-4">(يا دكتور… الوجع بقى مسيطر على يومي)</p>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            خشونة المفاصل مش وجع عادي
          </h3>
          <p class="text-lg leading-relaxed mb-4">
            ده وجع يوقف حركة، يقلّل نشاط، ويخلّي أبسط حاجة زي المشي مجهود.
            العلاج الصح مش مسكن وخلاص، العلاج الصح يبدأ بفهم الألم والتعامل معاه
            صح.
          </p>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            دهان موفكس للخشونة
          </h3>
          <p class="text-lg leading-relaxed mb-4">
            دهان موضعي، بيساعد على تخفيف الألم والتيبّس، وسريع الامتصاص… يعني
            راحة من غير ما تعطل يومك.
          </p>

          <h4 class="text-lg font-bold text-blue-600 mb-2">
            استشاري جراحة العظام والمفاصل
          </h4>
          <p class="text-lg leading-relaxed mb-4">
            أتعامل يوميًا مع عدد كبير من المرضى الذين يعانون من خشونة الركبة
            والمفاصل، سواء بسبب التقدم في العمر، زيادة الوزن، أو الإجهاد المتكرر
            للمفاصل.
          </p>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            ما هي خشونة العظام؟
          </h3>
          <ul class="list-disc list-inside text-lg space-y-2 mb-4">
            <li>ألم مستمر في الركبة أو المفاصل</li>
            <li>تيبس وصعوبة في الحركة</li>
            <li>صوت احتكاك أثناء المشي</li>
            <li>ضعف القدرة على ممارسة الحياة اليومية</li>
          </ul>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            لماذا أرشح دهان موفكس؟
          </h3>
          <ul class="list-disc list-inside text-lg space-y-2 mb-4">
            <li>مكونات تساعد على دعم الغضروف</li>
            <li>عناصر تساهم في تقليل الالتهاب والتيبس</li>
            <li>دعم مرونة المفصل وتحسين الحركة بشكل تدريجي</li>
          </ul>

          <p class="text-lg mb-4">
            وهذه التركيبة تجعله خيارًا مناسبًا للمرضى الذين:
          </p>
          <ol class="list-decimal list-inside text-lg space-y-2 mb-4">
            <li>يعانون من آلام الركبة المتكررة</li>
            <li>يشكون من خشونة المفاصل في بدايتها</li>
            <li>يريدون تقليل الاعتماد على المسكنات</li>
          </ol>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            هل المنتج بديل للعلاج؟
          </h3>
          <ul class="list-disc list-inside text-lg space-y-2 mb-4">
            <li>✔️ داعم قوي للمفاصل</li>
            <li>✔️ أقوى دهان يساعد على تحسين جودة الحياة</li>
            <li>✔️ فعال عند الانتظام عليه لفترة كافية مع نمط حياة صحي</li>
          </ul>

          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            نصيحتي للمرضى
          </h3>
          <ul class="list-disc list-inside text-lg space-y-2 mb-4">
            <li>لا تهمل ألم المفاصل</li>
            <li>ابدأ العلاج مبكرًا</li>
            <li>التزم بالتمارين المناسبة</li>
            <li>اختر دهان موثوقًا مثل دهان موفكس تحت إشراف طبي</li>
          </ul>

          <p class="text-xl font-bold text-green-700 mt-6">
            الوقاية والعلاج المبكر هما المفتاح للحفاظ على مفاصلك نشطة بدون ألم.
          </p>
        </section>

        {/* ✅ قسم ملفت في النهاية */}
        <section className="text-center p-12 mt-8 bg-gradient-to-r from-red-600 via-pink-500 to-yellow-500 rounded-lg shadow-lg">
          <h2 className="text-3xl font-extrabold text-white mb-6">
            سجل الآن لمعرفة التفاصيل والأسعار
          </h2>
          <button className="bg-white text-red-600 font-bold px-8 py-4 rounded-lg shadow-md hover:bg-gray-100 transition">
            سجل بياناتك الآن
          </button>
        </section>
      </div>
    </div>
  );
}

export default StoryTelling;
